import { MapPin, ChevronRight } from 'lucide-react'

export default function Listings() {
  return <section className="py-16"></section>
}
